var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7108 17.9818L10.0494 20.4507L7.63217 20.5019C6.90976 19.1619 6.5 17.6289 6.5 15.9998C6.5 14.4245 6.88312 12.9389 7.56222 11.6309H7.56274L9.71479 12.0254L10.6575 14.1645C10.4602 14.7398 10.3527 15.3573 10.3527 15.9998C10.3527 16.6972 10.4791 17.3653 10.7108 17.9818Z",
    fill: "#0082FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3341 14.2256C25.4432 14.8003 25.5001 15.3938 25.5001 16.0003C25.5001 16.6804 25.4286 17.3439 25.2924 17.9838C24.8299 20.1615 23.6215 22.0631 21.9476 23.4087L21.9471 23.4082L19.2364 23.2699L18.8528 20.8751C19.9636 20.2236 20.8316 19.2042 21.2889 17.9838H16.209V14.2256H21.363H25.3341Z",
    fill: "#0082FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.947 23.4084L21.9476 23.4089C20.3195 24.7175 18.2514 25.5004 16.0002 25.5004C12.3823 25.5004 9.2369 23.4783 7.63232 20.5025L10.711 17.9824C11.5132 20.1236 13.5787 21.6478 16.0002 21.6478C17.041 21.6478 18.016 21.3664 18.8528 20.8752L21.947 23.4084Z",
    fill: "#0082FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0636 8.68708L18.986 11.2067C18.1201 10.6654 17.0965 10.3527 15.9998 10.3527C13.5235 10.3527 11.4194 11.9468 10.6573 14.1647L7.56253 11.631H7.56201C9.14309 8.58269 12.3282 6.5 15.9998 6.5C18.3048 6.5 20.4183 7.32108 22.0636 8.68708Z",
    fill: "#0082FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBlue);
export default __webpack_public_path__ + "static/media/google-blue.f409bd61460e053c2dab492cc9600e94.svg";
export { ForwardRef as ReactComponent };